<div class="row">
    <div class="col-md-10">
        <div class="d-flex">
            <label class="form-label"> {{ defaultOptions.label }} </label>
            <span class="material-symbols-outlined mx-2 info-icon"
                *ngIf="defaultOptions.tooltipText"
                data-toggle="tooltip"
                data-placement="top"
                [title]="defaultOptions.tooltipText">
                    {{ defaultOptions.tooltipIcon }}
            </span>
        </div>
        <select [ngModel]="data?.selectedVersion" aria-placeholder="Select an option" class="form-select">
            @for (item of data?.versions; track item?.value) {
                <option> {{ item.label }} </option>
            }
        </select>
    </div>
    <div class="col-md-2 d-flex flex-column justify-content-end">
        <button class="btn  btn-accello-primary versioning-btn"> {{ defaultOptions.button?.text }} </button>
    </div>
</div>